import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchEventDetails } from "DashboardUserAction";
import ContentIcon, { HEADING_MAPS } from "ContentIcon";
import MapsHeaderButtons from "./headerbuttons";
import MapList from "./map-list";
import ALLMapList from "./all-map";
import LocaleStrings from "Languages";

class Maps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.content_text_preparing_map,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contentAvailable !== this.props.contentAvailable) {
      if (!nextProps.contentAvailable)
        this.props.history.push("/dashboard/content");
    }
  };

  componentDidMount() {
    /* Fetching event details */
    this.props.fetchEventDetails(this.props.session);
    /*** Fetch Both Map List (Union) ***/
    // this.props.fetchBothMapList(this.props.session,(CallBackResponse) => {
    //   this.setState({loading:false});
    // });
  }

  render() {
    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <ContentIcon heading={HEADING_MAPS} />
          </div>

          <MapsHeaderButtons history={this.props.history} />
        </div>
        <div className="clearfix"></div>

        {/* <div>
          <MapList />
        </div> */}

        <ALLMapList />
      </div>
    );
  }
}

function mapStateToProps(state) {
  var availableFeatures = state.availableFeatures.filter(
    (feature) => feature.available
  );
  var selectedFeature = availableFeatures.filter(
    (feature) => feature.bsClass === state.selectedContentFeature.bsClass
  );
  var contentAvailable = selectedFeature.length > 0;
  return {
    contentAvailable,
    session: state.session,
    deviceSize: state.deviceSize,
  };
}

var mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchEventDetails }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Maps);
